import {
    CREATE_HATCH,
    CREATE_HATCH_SUCCESS,
    UPDATE_HATCH,
    UPDATE_HATCH_SUCCESS,
    DELETE_HATCH,
    DELETE_HATCH_SUCCESS,
    GET_HATCHES_SUCCESS,
    HATCH_PIN,
    HATCH_PIN_SUCCESS,
    SAVE_VIEW_HATCH,
    SAVE_VIEW_HATCH_SUCCESS
} from './constants';

/**
 *
 * @param calendar_id
 * @param typeHatch
 * @param bgColor
 * @returns {{calendar_id: *, bgColor: *, type: string, typeHatch: *}}
 */
const createHatch = ( calendar_id, typeHatch, bgColor ) => ( {
    type: CREATE_HATCH,
    calendar_id,
    typeHatch,
    bgColor
} );
/**
 *
 * @param hatch
 * @returns {{hatch: *, type: string}}
 */
const createHatchSuccess = hatch => ( {
    type: CREATE_HATCH_SUCCESS,
    hatch
} );
/**
 *
 * @param calendar_id
 * @param hatchID
 * @param value
 * @returns {{calendar_id: *, hatchID: *, type: string, value: *}}
 */
const updateHatch = ( calendar_id, hatchID, value ) => ( {
    type: UPDATE_HATCH,
    calendar_id,
    hatchID,
    value
} );
/**
 *
 * @param hatch
 * @returns {{hatch: *, type: string}}
 */
const updateHatchSuccess = hatch => ( {
    type: UPDATE_HATCH_SUCCESS,
    hatch
} );
/**
 *
 * @param hatchID
 * @returns {{hatchID: *, type: string}}
 */
const deleteHatch = hatchID => ( {
    type: DELETE_HATCH,
    hatchID,
} );
/**
 *
 * @param hatches
 * @returns {{hatches: *, type: string}}
 */
const deleteHatchSuccess = hatches => ( {
    type: DELETE_HATCH_SUCCESS,
    hatches
} );
/**
 *
 * @param hatches
 * @returns {{hatches: *, type: string}}
 */
const getHatchesSuccess = hatches => ( {
    type: GET_HATCHES_SUCCESS,
    hatches
} );
/**
 *
 * @param hatchID
 * @returns {{hatchID: *, type: string}}
 */
const pinHatch = hatchID => ( {
    type: HATCH_PIN,
    hatchID
} );
/**
 *
 * @param hatch
 * @returns {{hatch: *, type: string}}
 */
const pinHatchSuccess = hatch => ( {
    type: HATCH_PIN_SUCCESS,
    hatch
} );
/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const saveViewHatch = ( id ) => ( {
    type: SAVE_VIEW_HATCH,
    id
} );
/**
 *
 * @param data
 * @returns {{data: *, type: string}}
 */
const saveViewHatchSuccess = data => ( {
    type: SAVE_VIEW_HATCH_SUCCESS,
    data
} );

export {
    createHatch,
    createHatchSuccess,
    updateHatch,
    updateHatchSuccess,
    deleteHatch,
    deleteHatchSuccess,
    getHatchesSuccess,
    pinHatch,
    pinHatchSuccess,
    saveViewHatch,
    saveViewHatchSuccess
};